import styled from 'styled-components'
import { usePage } from '../../contexts/PageProvider'
import SanityImage from '../sanity/SanityImage'
import { TypesetHeadingM } from '../typeset/Typeset';

interface P {
  children?: React.ReactNode
  className?: string
}
const PageLanding: React.FC<P> = ({ 
  className,
}: P) => {
  const page = usePage();
  const {image, caption} = page.landing;


  return (
    <Container className={className}>
      <Image alt={image.alt || ''} image={image} layout="fill" />
      <TypesetHeadingM caption={page.title} indent={5} content={caption} captionAlign="SUPER" />
    </Container>
  )
}

const Container = styled.div`
  margin-top: calc(-1 * var(--spacing-24));
  margin-bottom: var(--spacing-80);

`

const Image = styled(SanityImage)`
  height: calc(100 * var(--1vh) - var(--header-height) - var(--spacing-24));
  margin-bottom: var(--spacing-24);
`

export default PageLanding